import gql from 'graphql-tag';

export const CALENDAR_YEAR_TOTAL_RETURNS = gql`
    query CalendarYearTotalReturns($ticker: String!) {
        mutualFund(ticker: $ticker) {
            name: shortName
            iClass
            inceptionDate
            tenYearHistoricalReturns {
                fundReturn
                asOfDate
            }
            correspondingFund {
                inceptionDate
                tenYearHistoricalReturns {
                    fundReturn
                    asOfDate
                }
            }
            standardPerformanceReturns {
                quarterlyAnnualReturns {
                    fundPerformance {
                        oneYearReturnTacked
                        threeYearReturnTacked
                        fiveYearReturnTacked
                        tenYearReturnTacked
                        sinceInceptionReturnTacked
                    }
                }
            }
        }
    }
`;
